"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var provider_1 = require("./provider");
Object.defineProperty(exports, "provide", { enumerable: true, get: function () { return provider_1.provide; } });
//# sourceMappingURL=index.js.map